const constants = {
  MOJ_USER_NAME: "MojUser",
  MOJ_PHONE_NO: "9116969696969",
  COUNTRY_AREA_CODE: "91",
  MOJ_USER_LANGUAGE: "Hindi",
  MOJ_CLIENT: "MojPWA",
  MOJ_CLIENT_SERVER: "MojPWA-server",
  FEED_LANGUAGE: "Hindi",
  DEMO_CREDENTIAL: {
    "x-sharechat-userid": "94000000001",
    "x-sharechat-authorized-userid": "94000000001",
    "x-sharechat-secret": "07bd73fb18144920c8c4",
  },
  STAGING_DEMO_CREDENTIAL: {
    "x-sharechat-userid": "50102915",
    "x-sharechat-authorized-userid": "50102915",
    "x-sharechat-secret": "021116e41c84517606c9",
  },
  SHARE_LINK_WHATSAPP: "https://api.whatsapp.com/send?text=",
  WEBVIEW_ENVIRONMENT: {
    MOJ: "moj",
    SHARECHAT: "sharechat",
    MOJTT: "mojtt",
  },
  TENANTS: {
    MOJ: "moj",
    MOJTT: "mojtt",
    TAKATAK: "takatak",
  },
  DEFAULT_AUTH_TOKEN:
    "GlbkXI8CeznZsMsUGbkrIWUYevyQ/K3Be/to6tDNUVYYB4RU3TbxvvvUotIuGVHmcdoOpgLnSnZnWGHABh2yU75MkgGA0j9zKvnrM1nwgtOfwaw2QHg9YWw5hkv1T94yQTIYV+9jXcYaxzrR25MoOpdT8WVrvWOeK1VxDt7BvC3G8txxbPce+stWcGjwHc2hXay0ofECnTxoLfIVQxC5/mXDRyGK9Izg2dA1XKKDSBmP8L9cW5t9KA6kx1k9pRzXzh6ld/xbp7LljJOTOngEsBDdfA100EZMH6DZfkAaa0blgFQSlJ4N42fZW30M2g4G3bH1JlyKU/AbNfxdsRenIw==",
  ENTITY_TYPE_TO_IDENTIFIER_MAPPING: {
    post: "post",
    comment: "comment",
    group: "group",
    chatroom: "chatroom",
    chatroom_user: "chatroom",
    profile: "profile",
    post_tag: "tag",
    tag: "tag",
  },
  GRIEVANCE_ROUTES: {
    REPORTS: "reports",
    VIOLATIONS: "violatons",
  },
  GRIEVANCE_TICKET_STATUS: {
    OPEN: "open",
    CLOSED: "closed",
  },
  GRIEVANCE_COMPLAINT_TYPE: {
    VALID: "valid",
    INVALID: "invalid",
  },
  NO_MORE_POSTS_OFFSET: "no_more",
  DEFAULT_USER_PIC: "https://cdn-im.sharechat.com/295d8c15_1597741425818.png",
  DEFAULT_SRC:
    "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7",
  BUDDING_CREATOR_PROGRAM_URL:
    "/budding-creator-service/v1.0.0/external/bcp-details",
  REQUEST_ACCOUNT_DELETION:
    "content-m8n-service/external/v1.0.0/data-deletion/users",
  NOT_FOUND_URL: "/404",
  WIDGET_TYPES: {
    PHOTO: "PHOTO",
    LEADERBOARD: "LEADERBOARD",
    CATEGORY: "CATEGORY",
    PHOTO_WITH_LINK: "PHOTO_WITH_LINK",
    PHOTO_OR_VIDEO_WITH_CAPTION: "PHOTO_OR_VIDEO_WITH_CAPTION",
    TIMER: "TIMER",
    LIST_LEADERBOARD: "LIST_LEADERBOARD",
  },
  GAMIFICATION_PREFIX: "/creator-gamification-service/v1.0.0/public",
  TROPHIES_DETAIL_KEY: "/creator-trophies",
  CREATOR_JOURNEY_KEY: "/journey",
  DEFAULT_ERROR_MESSAGE: "Something went wrong. Please try again",
  QUEST_ALL_RESULT: "/gamification/quests/questAllResults",
  QUEST_ENDPOINT: "/gamification/quests",
  TROPHIES: "trophies",
  JOURNEY: "journey",
  DEFAULT_RETRIES: 3,
  DISABLE_REDIRECTION_SOURCES: ["gd", "link"],
  RECENT_TROPHIES: "recent-trophies",
  DEFAULT_TROPHY_STRIPES:
    "https://cdn4.sharechat.com/f07d4e7_1692865688440_sc.png",
  BACK_ARROW: "https://cdn4.sharechat.com/3a16310a_1691556004589_sc.png",
  USE_AUTH_VALIDATION: true,
  STATIC_BANNER: "https://cdn4.sharechat.com/402eb93_1694167311114_sc.png",
  ERROR_MESSAGE: "Something went wrong",
  SUN_EMOJI: "https://cdn4.sharechat.com/1a40d309_1697443934949_sc.png",
  OS_NAME: {
    WINDOWS: "windows",
    ANDROID: "android",
    IOS: "ios",
    LINUX: "linux",
    OSX: "osx",
  },
};

export default constants;
